function PickCompanyCtrl($scope, $uibModalInstance, companies) {
    'ngInject';

    let c;
    $scope.title = 'Pick Company';
    $scope.schema = {
        type: 'object',
        properties: {
            company_id: {type: 'integer', title: 'Company'}
        }
    };
    $scope.schema.properties.company_id.enum = ((() => {
        const result = [];
        for (c of Array.from(companies)) {
            result.push(c.id);
        }
        return result;
    })());
    $scope.form = [{
        key: 'company_id',
        type: 'select',
        titleMap: ((() => {
            const result1 = [];
            for (c of Array.from(companies)) {
                result1.push({value: c.id, name: c.name});
            }
            return result1;
        })()),
        autofocus: true
    }];
    $scope.pick_company_form = {};

    $scope.submit = form => $uibModalInstance.close(form.company_id);

    $scope.cancel = () => $uibModalInstance.dismiss('cancel');
}

export default PickCompanyCtrl;


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/member/login-member/pick_company.controller.js